<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/salma-mehboob.jpg" alt="Salma Mehboob">
          </figure>
       <div class="finger-print"><img src="@/assets/images/fingerprints/fingerprint-five.svg" alt=""></div>
      </div>
    </div>
    <div class="profile-statement">

 <h2>Salma Mehboob</h2>
      <p class="job-title">Programme Support Tutor</p>  

<p class="profile-statement-interviewer">Tell us a little bit about yourself</p>

<p>I work in the Department of Psychology as a Programme Support Tutor. Prior to this, I was a teacher working in schools and a sixth form. I have always been in education - either studying or working in the area! Currently, I work with MSc students, supporting them in a variety of roles. I also support teaching staff on various units, as well as co-chair for the Equality, Diversity and Inclusion team. I do wear a lot of hats (or hijabs!), but I love that my job allows room for this. Outside of work, I have many interests and projects. I am involved in currently recording a series of podcasts and am constantly on the go - a real ball of energy!</p>

<p class="profile-statement-interviewer">What inspires you within your role?</p>

<p>The challenge of the job itself. Every day is unpredictable, and I thrive off this as it means I am learning new information every day! Also, knowing that I can help make meaningful decisions that ensure students can progress and do well in their studies. I have a natural curiosity and imagination, and my role provides me with the freedom to use this in a way to help students and staff. This brings a huge sense of achievement for me.</p>

<p class="profile-statement-interviewer">What is something that you love about your culture or heritage? </p>

<p>I love that I can embrace many cultures and do not aspire to follow a unidimensional culture because they all align to my core values and beliefs. Having said that, I appreciate the customs and the traditions, especially ones connected to the various cultures I am surrounded by and immerse myself in. For example, I love the arts, music and theatre that South Asian culture has contributed to the world. Further to this, I love the community I am surrounded by. They are a great source of social connection and sense of belonging and this is especially important for all kinds of support, growth, and learning from one another.</p>

<p class="profile-statement-interviewer">What does it look like to bring your whole self to your work? </p>

<p>Being able to bring all the dimensions of my personality and character that make me who I am and matter to me. Not having to hide any part of who I am that might be perceived as ‘different’ by others. Being accepted for me ‘Salma’ who is seen as a 3-dimensional human</p>

<p>being rather than ‘Asian Muslim who wears a hijab’. I am blessed that I can bring my whole self to work and be confident in presenting my own self, authentically to others.</p>

<p class="profile-statement-interviewer">How do you think MMU can best celebrate their Black, Asian, and Ethnic Minority staff and students? </p>

<p>We need a university-wide collaboration so that people of colour can meet others and arrange events or festivals that people might share to develop a sense of belonging. For example, an Eid celebration event for all staff (not just departmental events). I just don’t meet anyone of similar heritage from other departments, but meeting people whose heritage might be like mine really does create a sense of connection. I recently have started working with another Asian woman from the faculty and it’s lovely to connect in so many ways, sharing lots of ideas that we can implement on a faculty level.</p>

<p class="profile-statement-interviewer">What are you most proud of?</p>

<p>I am most proud of being able to adapt and grow at all stages of my life, especially the last 5 years in all areas of my life - physically, emotionally, spiritually and intellectually. I should write a book!</p>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  .profile-container {
  flex-direction: row-reverse;
  }

  .profile-portrait-container {
    justify-content: flex-end;

    & figure {
      text-align: right;
    }
  }

  // .profile-statement {
  //   padding-right: 5rem;
  //   // padding-left: 5rem;
  // }

</style>